import { Box, useMediaQuery, useTheme } from '@mui/material';
import { FC, useState } from 'react';
import { FieldValues } from 'react-hook-form';
import LoginWithEmailForm from '../LoginWithEmail/LoginWithEmailForm';
import LoginWithEmailResendLink from '../LoginWithEmail/LoginWithEmailResendLink';
import LoginWithEmailTipsDialog from '../LoginWithEmail/LoginWithEmailTipsDialog';
import LoginWithEmailTipsDrawer from '../LoginWithEmail/LoginWithEmailTipsDrawer';
import { containerWrapper } from './ExpiredMagicLink.styles';
import { useEmailLogin } from '@src/services/useEmailLogin';
import usePatientInformationStorePS from '@src/store/modules/patient-services/patient-information.store';
const ExpiredMagicLink: FC = () => {
  const {
    isPending,
    emailLoginMutation
  } = useEmailLogin();
  const [isTipsDialogVisible, setIsTipsDialogVisible] = useState(false);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const {
    patientInformation,
    setPatientInformation
  } = usePatientInformationStorePS(store => store);
  const toggleTipsDialog = () => {
    setIsTipsDialogVisible(!isTipsDialogVisible);
  };
  const handleOnSubmit = async (emailPayload: FieldValues) => {
    await emailLoginMutation(emailPayload);
    setPatientInformation({
      email: emailPayload.email
    });
  };
  return <Box data-sentry-element="Box" data-sentry-component="ExpiredMagicLink" data-sentry-source-file="ExpiredMagicLink.tsx">
			<Box sx={containerWrapper({
      isSmallScreen
    })} data-sentry-element="Box" data-sentry-source-file="ExpiredMagicLink.tsx">
				{!patientInformation?.email ? <LoginWithEmailForm buttonText="Send new link" handleOnSubmit={handleOnSubmit} title="Your link has expired" description="Please enter your email address below to get a new link via email." expiredPage isPending={isPending} /> : <LoginWithEmailResendLink expiredPage handleOnSubmit={handleOnSubmit} email={patientInformation?.email} toggleTipsDialog={toggleTipsDialog} />}
			</Box>
			{isSmallScreen ? <LoginWithEmailTipsDrawer isTipsDialogVisible={isTipsDialogVisible} toggleTipsDialog={toggleTipsDialog} /> : <LoginWithEmailTipsDialog isTipsDialogVisible={isTipsDialogVisible} toggleTipsDialog={toggleTipsDialog} />}
		</Box>;
};
export default ExpiredMagicLink;